import React from 'react'
import "./Work.css";

import Portfolio from './port';


const Work = () => {
    return (
        <section className="work section " id='portfolio'>
            <h2 className="section__title">Portfolio</h2>
            <span className="section__subtitle">Most recent works</span>

            <Portfolio />


        </section>
    )
}

export default Work
